import { createMuiTheme } from '@material-ui/core/styles';

let theme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 4
      }
    },
    MuiDrawer: {
      paper: {
        width: 150,
        minWidth: 64
      },
      paperAnchorLeft: {
        backgroundColor: '#f4f4f4'
      },
      paperAnchorDockedLeft: {
        borderRight: 0
      }
    },
    MuiTypography: {
      display4: {
        color: '#777'
      },
      display3: {
        color: '#777'
      },
      display2: {
        color: '#777'
      },
      display1: {
        color: '#777'
      },
      title: {
        color: '#777'
      },
      subheading: {
        color: '#777'
      },
      body2: {
        color: '#777'
      },
      body1: {
        color: '#777'
      },
      caption: {
        color: '#777'
      },
      button: {
        color: '#777'
      }
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      default: {
        paddingTop: 17,
        paddingBottom: 17
      }
    },
    MuiListItemText: {
      root: {
        padding: 0
      },
      primary: {
        letterSpacing: 0.3,
        fontWeight: 700,
        fontSize: 10,
        color: '#c0bec1',
        whiteSpace: 'nowrap'
      }
    },
    MuiPaper: {
      rounded: {
        margin: 0,
        minHeight: '50%',
        padding: 0,
        MuiSvgIcon: {
          root: {
            color: '#777',
            fontSize: 80,
            marginBottom: '0.35em'
          }
        }
      }
    }
  },
  palette: {
    background: {
      default: '#fff'
    },
    primary: {
      main: '#4984c1'
    }
  },
  shadows: Array(25).fill('none'),
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Lato,sans-serif',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif'
    ].join(',')
  }
});

theme.overrides.MuiTypography.headline = {
  color: 'inherit',
  flex: 'auto',
  fontSize: '3.5em',
  marginLeft: 130,
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5em',
    marginLeft: 0
  },
  [theme.breakpoints.down('xs')]: {
    fontSize: '1.5em',
    marginLeft: 0
  }
};

theme.overrides.MuiToolbar = {
  root: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 145
    }
  }
};

theme.overrides.MuiListItem.gutters = {
  paddingLeft: 19,
  paddingRight: 16,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 19,
    paddingRight: 16
  }
};

theme.mixins.toolbar[theme.breakpoints.up('sm')] = {
  minHeight: 145
};

//console.log(theme);

export default theme;



// WEBPACK FOOTER //
// ./src/components/layout/AlulaTheme.js